import * as React from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import FormComponent from 'modules/core/components/Form'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useEffect } from 'modules/core/hooks/useEffect'

import { AutomationStep } from 'modules/automations/components/Show/Step'
import { automationSteps } from 'modules/automations/components/Show/Step/constants'
import { getActionName } from 'modules/automations/components/Show/actionUtils'
import type { Action } from 'modules/automations/store/models/Action'
import { templates as templatesCollection } from 'modules/custom_resources/store/collections/customTemplates/templates'

import Selects from './Selects'

interface Props {
  action: Action
  form: Form | undefined
  onClick?: () => void
  withLastSpacer?: boolean
}

export const SendCustomNotificationAction = observer(
  ({ action, form, onClick, withLastSpacer }: Props) => {
    const isDefault = !!action.automation?.isDefault

    const { loading } = useAsyncData(async () => {
      await templatesCollection.fetch()
    }, [])

    useEffect(() => {
      return () => {
        form?.setValues({
          recipient: null,
          notifiable_id: null,
          notifiable_ids: [],
        })
      }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const { notifiable_ids, notifiable_id, recipient } = form?.data() as unknown as {
      notifiable_ids: string[]
      notifiable_id: string
      recipient: string
    }
    const validRecipient = !!recipient || notifiable_id || notifiable_ids?.length

    return (
      <AutomationStep
        action={action}
        disabled={isDefault}
        onClick={onClick}
        stepType={automationSteps.action}
        withLastSpacer={withLastSpacer}
        title={getActionName(action)}
        conflict={!validRecipient}
      >
        <Box paddingX="s16" paddingBottom="s16">
          <FormComponent>
            {loading && (
              <Box padding="s40" width="full" alignItems="center">
                <Spinner />
              </Box>
            )}
            {!loading && form && <Selects action={action} disabled={isDefault} form={form} />}
          </FormComponent>
        </Box>
      </AutomationStep>
    )
  }
)
